import * as classnames from 'classnames'
import * as React from 'react'
import FavoriteIcon from '../../../../shared/components/icons/favorite'
import CircleButton from '../../buttons/circleButton'

import * as styles from './favoriteButton.module.css'

interface IProps
  extends React.AnchorHTMLAttributes<HTMLAnchorElement | HTMLButtonElement> {
  isActive?: boolean
}

const FavoriteButton = ({
  href,
  onClick,
  isActive = false,
  className = ''
}: IProps) => {
  const classes = classnames(styles.link, {
    [styles.linkActive]: isActive,
    [className]: !!className
  })

  return (
    <CircleButton
      href={href}
      className={classes}
      onClick={onClick}
      title="Add to Favorites"
      rel="nofollow"
    >
      <FavoriteIcon width="20" height="16" className={styles.icon} />
    </CircleButton>
  )
}

export default FavoriteButton
